const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const buildHeaders = (token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      ...buildHeaders(options.token),
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "Request failed");
  }

  return data;
};

export const authApi = {
  register: (payload) =>
    request("/auth/register", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  login: (payload) =>
    request("/auth/login", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};

export const profileApi = {
  getMe: (token) =>
    request("/profile/me", {
      method: "GET",
      token,
    }),
  updateMe: (token, payload) =>
    request("/profile/me", {
      method: "PUT",
      token,
      body: JSON.stringify(payload),
    }),
};

export const authStorage = {
  getToken: () => localStorage.getItem("gr_token"),
  setToken: (token) => localStorage.setItem("gr_token", token),
  clearToken: () => localStorage.removeItem("gr_token"),
};
